import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { Customer, ManagedUserFilterLists } from '@pos-app/data';
import { select, Store } from '@ngrx/store';
import { ManageusersPartialState } from '../../manageusers/+state/manageusers.reducer';
import { manageusersQuery } from '../../manageusers/+state/manageusers.selectors';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { LoadLookupLists, UpdateNewPartnerProgrammeList } from '../../manageusers/+state/manageusers.actions';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService, DialogService, getHasUnsavedChanges, hasUnsavedChanges, MessageService } from '@pos-app/core-ui';

import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CoreUiModule } from '../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { MatIcon } from '@angular/material/icon';
import { ManagePartnerEnrollment } from '../components/manage-partner-enrollment/manage-partner-enrollment.component';
@Component({
    selector: 'app-manageusers',
    templateUrl: './partnerprogram.component.html',
    styleUrls: ['./partnerprogram.component.scss'],
    imports: [CoreUiModule, NgIf, FormsModule, ReactiveFormsModule, NgSelectComponent, NgFor, NgOptionComponent, NgClass, NgbInputDatepicker, MatIcon, ManagePartnerEnrollment, AsyncPipe]
})
export class PartnerProgramComponent implements OnInit {
  @ViewChild('content') modalBox: any;

  lookupLists$: Observable<ManagedUserFilterLists>;
  private unSubscribe$ = new Subject<void>();
  updatePartnerProgramme: UntypedFormGroup;
  selectedPartnerProgramme: string;
  selectedCustomer: Customer;
  isAddingNewPartnerProgramme: boolean = false;
  vehicleListMake = [];
  public subject = new Subject();
  existingProgrammeCode: boolean = false;
  formValid: boolean = false;
  initialFormValue: any;
  preOverrideCustomerNumber: string;
  preGenericQuoteCustomerNumber: string;
  removeCustomerAfterLoad: boolean = false;
  hasUnsavedChanges: boolean;
  isEnrollPartnerToProgram: boolean = false;
  selectBlankValue: boolean = false;

  constructor(
    private store: Store<ManageusersPartialState>,
    private formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private toastr: ToastrService,
    private messageService: MessageService,
    private router: Router,
    private dialogService: DialogService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.store.dispatch(new LoadLookupLists());
    this.lookupLists$ = this.store.select(manageusersQuery.getLookupLists);
    //get vehilces list by make
    this.searchVehicle();
    //Initialize form group with default values and validators
    this.updatePartnerProgramme = this.formBuilder.group({
      partnerProgramme: [''],
      programmeCode: ['', Validators.required],
      programmeName: ['', Validators.required],
      effectiveDate: ['', Validators.required],
      expiryDate: ['', Validators.required],
      overrideCustomerNumber: [''],
      filterVehicleMake: [''],
      menuFilterCategory: [''],
      defaultCustomerXrefTF: [false],
      hideBuyPriceTF: [false],
      saveQuotesTF: [false],
      validOrderTypes: [''],
      genericQuoteCustomerNumber: [''],
      genericQuotesOnlyTF: [false],
      customPricingFunction: [''],
      helpMessage: [''],
    });

    this.updatePartnerProgramme.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$)).subscribe((val) => {
      this.compareValues();
    });

    //on change of partner programme patchvalue to form group

    this.updatePartnerProgramme
      .get('partnerProgramme')
      .valueChanges.pipe(takeUntil(this.unSubscribe$))
      .subscribe((value) => {
        //pass selected partner programme to lookupLists$ observable and find the selected partner programme and patch value to form group
        this.lookupLists$.pipe(takeUntil(this.unSubscribe$)).subscribe((data) => {
          const partnerProgramme = data.partnerProgrammeList.find((x) => x.programmeCode === value);
          if (partnerProgramme && this.updatePartnerProgramme.get('partnerProgramme').value) {
            this.isAddingNewPartnerProgramme = false;
            this.updatePartnerProgramme.patchValue({
              programmeCode: partnerProgramme?.programmeCode,
              programmeName: partnerProgramme?.programmeName,
              effectiveDate: partnerProgramme?.effectiveDate,
              expiryDate: partnerProgramme?.expiryDate,
              overrideCustomerNumber: partnerProgramme?.overrideCustomerNumber || '',
              filterVehicleMake: partnerProgramme?.filterVehicleMake || '',
              menuFilterCategory: partnerProgramme?.menuFilterCategory,
              defaultCustomerXrefTF: partnerProgramme?.defaultCustomerXrefTF,
              hideBuyPriceTF: partnerProgramme?.hideBuyPriceTF,
              saveQuotesTF: partnerProgramme?.saveQuotesTF,
              validOrderTypes: partnerProgramme?.validOrderTypes,
              genericQuoteCustomerNumber: partnerProgramme?.genericQuoteCustomerNumber,
              genericQuotesOnlyTF: partnerProgramme?.genericQuotesOnlyTF,
              customPricingFunction: partnerProgramme?.customPricingFunction,
              helpMessage: partnerProgramme?.helpMessage,
            });
            this.preOverrideCustomerNumber = partnerProgramme?.overrideCustomerNumber?.toString();
            this.preGenericQuoteCustomerNumber = partnerProgramme?.genericQuoteCustomerNumber?.toString();
            this.initialFormValue = this.updatePartnerProgramme.getRawValue();
          } else {
            this.initialFormValue = {
              partnerProgramme: '',
              programmeCode: '',
              programmeName: '',
              effectiveDate: '',
              expiryDate: '',
              overrideCustomerNumber: '',
              filterVehicleMake: '',
              menuFilterCategory: '',
              defaultCustomerXrefTF: false,
              hideBuyPriceTF: false,
              saveQuotesTF: false,
              validOrderTypes: '',
              genericQuoteCustomerNumber: '',
              genericQuotesOnlyTF: false,
              customPricingFunction: '',
              helpMessage: '',
            };
          }
        });
        this.compareValues();
      });

    //check if the form effecitve date is greater than expiry date and vice versa
    this.updatePartnerProgramme
      .get('effectiveDate')
      .valueChanges.pipe(takeUntil(this.unSubscribe$))
      .subscribe((value) => {
        const expiryDate = this.updatePartnerProgramme.get('expiryDate').value;
        if ((expiryDate && this.parseDate(value) > this.parseDate(expiryDate)) || !expiryDate) {
          this.updatePartnerProgramme.get('effectiveDate').setErrors({ invalidDate: true });
          if (expiryDate) {
            this.updatePartnerProgramme.get('expiryDate').setErrors({ required: true });
          } else if (!expiryDate) {
            this.updatePartnerProgramme.get('expiryDate').setErrors({ required: true });
          }
        } else if (expiryDate) {
          this.updatePartnerProgramme.get('effectiveDate').setErrors(null);
          this.updatePartnerProgramme.get('expiryDate').setErrors(null);
        }
      });

    this.updatePartnerProgramme
      .get('expiryDate')
      .valueChanges.pipe(takeUntil(this.unSubscribe$))
      .subscribe((value) => {
        const effectiveDate = this.updatePartnerProgramme.get('effectiveDate').value;
        if ((effectiveDate && this.parseDate(effectiveDate) > this.parseDate(value)) || !effectiveDate) {
          if (effectiveDate) {
            this.updatePartnerProgramme.get('expiryDate').setErrors({ invalidDate: true });
          } else if (!effectiveDate) {
            this.updatePartnerProgramme.get('effectiveDate').setErrors({ invalidDate: true });
          }
        } else if (effectiveDate) {
          this.updatePartnerProgramme.get('effectiveDate').setErrors(null);
          this.updatePartnerProgramme.get('expiryDate').setErrors(null);
        }
      });

    this.updatePartnerProgramme
      .get('programmeCode')
      .valueChanges.pipe(takeUntil(this.unSubscribe$))
      .subscribe((value) => {
        this.lookupLists$.pipe(takeUntil(this.unSubscribe$)).subscribe((data) => {
          if (
            this.isAddingNewPartnerProgramme &&
            data.partnerProgrammeList.some((x) => x.programmeCode?.toLocaleLowerCase() === value?.toLocaleLowerCase())
          ) {
            this.updatePartnerProgramme.get('programmeCode').setErrors({ invalidDate: true });
            this.existingProgrammeCode = true;
          } else {
            this.existingProgrammeCode = false;
          }
        });
      });
  }
  cancel() {
    this.resetUpdatePartnerProgramme();
    this.isAddingNewPartnerProgramme = false;
    this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
    this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
  }
  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  save() {
    //check if isAddingNewPartnerProgramme
    if (this.isAddingNewPartnerProgramme) {
      //add new partner programme
      this.apiService.createPartnerProgramme(this.updatePartnerProgramme.value).subscribe((data) => {
        //show success message
        this.resetUpdatePartnerProgramme();
        if (data.ErrorFlag === '0') {
          this.toastr.success('Partner Programme added successfully');
          this.isAddingNewPartnerProgramme = false;
          this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
          this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
          this.apiService.fetchPartnerProgrammes({}).subscribe((data) => {
            this.store.dispatch(new UpdateNewPartnerProgrammeList({ partnerProgrammeList: data?.SearchResults }));
          });
        }
      });
    } else {
      //delete the partner programme from the form group before saving
      delete this.updatePartnerProgramme.value.partnerProgramme;
      this.apiService.updatePartnerProgramme(this.updatePartnerProgramme.value).subscribe((data) => {
        //show success message
        this.resetUpdatePartnerProgramme();
        if (data.ErrorFlag === '0') {
          this.toastr.success('Partner Programme updated successfully');
          this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
          this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
          this.apiService.fetchPartnerProgrammes({}).subscribe((data) => {
            this.store.dispatch(new UpdateNewPartnerProgrammeList({ partnerProgrammeList: data?.SearchResults }));
          });
        }
      });
    }
    // this.store.dispatch(new ResetLookuplist());

    this.resetUpdatePartnerProgramme();
    this.store.dispatch(new LoadLookupLists());
  }

  selectCustomerOverrideBillTo(e) {
    this.selectedCustomer = e;
    if (this.selectedCustomer && !this.selectBlankValue) {
      this.preOverrideCustomerNumber = this.selectedCustomer.customerNumber.toString();
      this.updatePartnerProgramme.patchValue({ overrideCustomerNumber: e.customerNumber });
    } else {
      this.updatePartnerProgramme.patchValue({
        orverrideCustomerNumber: '',
      });
    }
  }

  selectCustomerGenericQuote(e) {
    this.selectedCustomer = e;
    if (this.selectedCustomer) {
      this.preGenericQuoteCustomerNumber = this.selectedCustomer.customerNumber.toString();
      this.updatePartnerProgramme.patchValue({ genericQuoteCustomerNumber: e.customerNumber });
    }
  }

  //adding new partner programme
  addNewPartnerProgramme() {
    this.confirmIgnoreChanges().subscribe((confirmed) => {
      if (confirmed) {
        this.isAddingNewPartnerProgramme = true;
        //avoid null while this.updatePartnerProgramme.reset()
        this.resetUpdatePartnerProgramme();
        this.formValid = false;
      }
    });
  }

  public searchVehicle(): void {
    let searchParams = {
      brand: '',
      make: '',
      year: '',
      searchString: '',
      model: '',
      generation: '',
      subModel: '',
      chassis: '',
      series: '',
      bodyType: '',
      driveType: '',
      transmissionType: '',
      engineType: '',
      engineCode: '',
    };

    this.apiService
      .vehicleSearch(searchParams)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data: any) => {
        this.vehicleListMake = data.Make;
      });
  }

  compareValues() {
    const currentFormValue = this.updatePartnerProgramme.getRawValue();
    if (JSON.stringify(currentFormValue) !== JSON.stringify(this.initialFormValue) && this.updatePartnerProgramme.controls.programmeName?.value) {
      this.formValid = true;
      this.store.dispatch(hasUnsavedChanges({ unsavedChanges: true }));
      this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: true }));
    } else {
      this.formValid = false;
      this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
      this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
    }
  }
  resetFormSelectedProgram() {
    //pass selected partner programme to lookupLists$ observable and find the selected partner programme and patch value to form group
    this.lookupLists$.pipe(takeUntil(this.unSubscribe$)).subscribe((data) => {
      const partnerProgramme = data.partnerProgrammeList.find((x) => x.programmeCode === this.updatePartnerProgramme.get('partnerProgramme').value);
      if (partnerProgramme) {
        this.isAddingNewPartnerProgramme = false;
      }
      this.updatePartnerProgramme.patchValue({
        programmeCode: partnerProgramme?.programmeCode,
        programmeName: partnerProgramme?.programmeName,
        effectiveDate: partnerProgramme?.effectiveDate,
        expiryDate: partnerProgramme?.expiryDate,
        overrideCustomerNumber: partnerProgramme?.overrideCustomerNumber,
        filterVehicleMake: partnerProgramme?.filterVehicleMake,
        menuFilterCategory: partnerProgramme?.menuFilterCategory,
        defaultCustomerXrefTF: partnerProgramme?.defaultCustomerXrefTF,
        hideBuyPriceTF: partnerProgramme?.hideBuyPriceTF,
        saveQuotesTF: partnerProgramme?.saveQuotesTF,
        validOrderTypes: partnerProgramme?.validOrderTypes,
        genericQuoteCustomerNumber: partnerProgramme?.genericQuoteCustomerNumber,
        genericQuotesOnlyTF: partnerProgramme?.genericQuotesOnlyTF,
        customPricingFunction: partnerProgramme?.customPricingFunction,
        helpMessage: partnerProgramme?.helpMessage,
      });
      this.preOverrideCustomerNumber = partnerProgramme?.overrideCustomerNumber.toString();
      this.preGenericQuoteCustomerNumber = partnerProgramme?.genericQuoteCustomerNumber.toString();
    });
    this.formValid = false;
    this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
    this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
  }
  parseDate(dateStr) {
    if (!dateStr) return null;

    let parts = dateStr.split('/');
    // Note: Months are 0-based in JavaScript Date (0 = January, 11 = December)
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }

  navigateTo(url) {
    this.confirmIgnoreChanges().subscribe((confirmed) => {
      if (confirmed) {
        this.router.navigateByUrl(url);
      }
    });
  }

  confirmIgnoreChanges(url = ''): Observable<boolean> {
    if (this.formValid) {
      return this.dialogService
        .confirm(
          `Are you sure you want to leave this page? Select No to go back and save your update,
        or select Yes to leave this page and discard your changes.
        You have unsaved changes!`
        )
        .pipe(
          takeUntil(this.unSubscribe$),
          map((val) => {
            if (val) {
              this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
              this.hasUnsavedChanges = false;
              if (url) {
                this.router.navigateByUrl(url);
              }
              return true;
            } else {
              return false;
            }
          })
        );
    } else {
      return of(true);
    }
  }
  openModalBox() {
    this.modalService
      .open(this.modalBox, {
        windowClass: 'garage-modal',
        size: 'xl',
        backdrop: 'static',
      })
      .result.then(
        (_) => {
          this.isEnrollPartnerToProgram = false;
        },
        (_) => {
          this.isEnrollPartnerToProgram = false;
        }
      );
  }

  openEnrollToProgram() {
    this.isEnrollPartnerToProgram = true;
    this.openModalBox();
  }
  handleCloseModal() {
    this.modalService.dismissAll();
  }
  enrollToProgram() {}

  resetUpdatePartnerProgramme() {
    this.updatePartnerProgramme.patchValue({
      partnerProgramme: '',
      programmeCode: '',
      programmeName: '',
      effectiveDate: '',
      expiryDate: '',
      overrideCustomerNumber: '',
      filterVehicleMake: '',
      menuFilterCategory: '',
      defaultCustomerXrefTF: false,
      hideBuyPriceTF: false,
      saveQuotesTF: false,
      validOrderTypes: '',
      genericQuoteCustomerNumber: '',
      genericQuotesOnlyTF: false,
      customPricingFunction: '',
      helpMessage: '',
    });
    this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
    this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
  }

  allowBlankValue() {
    this.selectBlankValue = !this.selectBlankValue;
    if (this.selectBlankValue) {
      this.updatePartnerProgramme.get('overrideCustomerNumber').setValue('');
    } else {
      this.updatePartnerProgramme.get('overrideCustomerNumber').setValue(this.preOverrideCustomerNumber || '');
    }
  }
}

